import React from 'react'
import { NOTIFICATION_STATUSES } from './constants'

export default function FCMDataTable({ notifications, onSelected, onDeleted }) {
  if (!notifications) return null

  return (
    <table className="table table-hover">
      <thead>
        <tr>
          <th>สถานะ</th>
          <th>หัวข้อ</th>
          <th>รายละเอียด</th>
          <th>สร้างเมื่อ</th>
          <th>กำหนดเวลาเผยแพร่</th>
          <th>ลบ</th>
        </tr>
      </thead>
      <tbody>
        {notifications.map((notification) => {
          const info = JSON.parse(notification.payload)
          const statusClass = getStatusClass(notification.status)
          const statusText = getStatusText(notification.status)
          return (
            <tr key={notification.id}>
              <td onClick={() => onSelected(notification)}>
                <span className={statusClass}>{statusText}</span>
              </td>
              <td onClick={() => onSelected(notification)}>{info.messages.title}</td>
              <td onClick={() => onSelected(notification)}>{info.messages.body}</td>
              <td onClick={() => onSelected(notification)}>{`${new Date(notification.createdAt).toLocaleString(
                'th-TH',
              )}`}</td>
              <td onClick={() => onSelected(notification)}>{`${new Date(notification.schedule).toLocaleString(
                'th-TH',
              )}`}</td>
              <td>
                {['DRAFT', 'IN_PROGRESS'].includes(notification.status) && (
                  <div style={{ cursor: 'pointer' }} onClick={() => onDeleted(notification.id)}>
                    ลบ
                  </div>
                )}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

const getStatusClass = (status) => {
  switch (status) {
    case NOTIFICATION_STATUSES.PUBLISH:
    case NOTIFICATION_STATUSES.IN_PROGRESS:
      return 'badge badge-success'
    case NOTIFICATION_STATUSES.DRAFT:
      return 'badge badge-light'
    case NOTIFICATION_STATUSES.CANCEL:
      return 'badge badge-warning'
    case NOTIFICATION_STATUSES.FAILED:
      return 'badge badge-danger'
    default:
      return 'badge badge-secondary'
  }
}

const getStatusText = (status) => {
  switch (status) {
    case NOTIFICATION_STATUSES.PUBLISH:
      return 'เผยแพร่แล้ว'
    case NOTIFICATION_STATUSES.IN_PROGRESS:
      return 'กำลังดำเนินการ'
    case NOTIFICATION_STATUSES.DRAFT:
      return 'แบบร่าง'
    case NOTIFICATION_STATUSES.CANCEL:
      return 'ยกเลิก'
    case NOTIFICATION_STATUSES.FAILED:
      return 'ไม่สำเร็จ'
    default:
      return 'ยังไม่เผยแพร่'
  }
}
